import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { Disableable, getTextTokenPreset, getToken } from '@optimus-web/common';
import { BareIconButton } from '../BareIconButton';
import {
    getActiveBackgroundColor,
    getActiveColor,
    getBackgroundColor,
    getColor,
    getHoverBackgroundColor,
    getHoverColor,
} from './getChipStyles';

export const ChipContainer = styled.div<Disableable & { error?: boolean }>`
    display: inline-flex;
    padding: 0 ${getToken(TokenName.SPACING_50)}px 0 ${getToken(TokenName.SPACING_100)}px;
    gap: ${getToken(TokenName.SPACING_50)}px;
    background-color: ${(props) => getBackgroundColor(props)};
    &:hover {
        background-color: ${(props) => getHoverBackgroundColor(props)};
    }

    &:active {
        background-color: ${(props) => getActiveBackgroundColor(props)};
    }
    border-radius: ${getToken(TokenName.BORDER_RADIUS_100)}px;
    align-items: center;
    overflow: hidden;
    cursor: auto;
    height: ${getToken(TokenName.SIZING_300)}px;
`;

export const ChipText = styled.div<Disableable & { error?: boolean }>`
    ${getTextTokenPreset('BODY_M')};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${(props) => getColor(props)};
`;

export const ChipIconButton = styled(BareIconButton)<Disableable & { error?: boolean }>`
    color: ${(props) => getColor(props)};
    &:hover:enabled {
        color: ${(props) => getHoverColor(props)};
    }
    &:active:enabled {
        color: ${(props) => getActiveColor(props)};
    }
`;
